import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate, useSearchParams } from "react-router-dom";

export const CompleteStep = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleContinue = () => {
    navigate("/app");
  };
  return (
    <>
      <h1 className="bg-tertiary rounded-lg text-xl text-white p-2">{`Step ${searchParams.get(
        "stepId"
      )}`}</h1>
      <h2 className="text-xl">That's It (for now)</h2>
      <p>
        You still need to set up agenda templates and letterheads, but for now,
        that's all that the guided setup has available for you!
      </p>
      <div className="flex flex-row justify-end w-full">
        <Button onClick={() => handleContinue()}>Continue</Button>
      </div>
    </>
  );
};
